// "Select Your Design" catalog — flake blends, stone/quartz and solid colors.
const slug = (n) => n.toLowerCase().replace(/\s+/g, "-");
const flakeImg = (n) => ({ name: n, src: `/images/flakes/${slug(n)}.jpg` });

const FLAKE_NAMES = [
  // High-resolution uploads first (in upload order)
  "Carbon", "Garnet", "Dolerite", "Domino", "Gravel", "Shoreline",
  "Coyote", "Wombat", "Creekbed", "Tidal Wave", "Raven", "Buffalo",
  // Remaining original blends
  "Orbit", "Cabin Fever", "Basalt", "Outback", "Stonewash", "Obsidian",
  "Turquoise", "Sandstone", "Acadia", "Schist", "Nightfall", "Pecan",
  "Stonehenge",
];

const STONE_NAMES = ["Whitestone", "Greystone", "Flintstone", "Gemstone", "Blackstone", "Bluestone"];

const SOLID_COLORS = [
  { name: "Light Gray", color: "#929699" },
  { name: "Mid Gray", color: "#787B82" },
  { name: "Dark Concrete", color: "#4B545D" },
  { name: "Concrete Gray", color: "#6E7275" },
  { name: "Beige", color: "#A99675" },
  { name: "Sand", color: "#C0B099" },
  { name: "Tan", color: "#AC9A76" },
  { name: "Beachwood", color: "#6B5F53" },
  { name: "White", color: "#D8D6CA" },
  { name: "Black", color: "#101010" },
  { name: "Safety Yellow", color: "#D2B53D" },
  { name: "Safety Red", color: "#BC372E" },
  { name: "Brick Red", color: "#803C31" },
  { name: "Pale Blue", color: "#77889A" },
  { name: "Sapphire Blue", color: "#222D4B" },
  { name: "Granit Green", color: "#464942" },
];

export const DESIGN_CATEGORIES = [
  { id: "flakes", label: "Flake Blends", type: "image", items: FLAKE_NAMES.map(flakeImg) },
  { id: "stone", label: "Stone & Quartz", type: "image", items: STONE_NAMES.map(flakeImg) },
  { id: "solids", label: "Solid Colors", type: "color", items: SOLID_COLORS },
];
